<template>
  <Chat
    v-if="
      !newCall &&
      atendimento &&
      (atendimento.queueTypeID === 3 ||
        atendimento.queueTypeID === 5 ||
        atendimento.queueTypeID === 6 ||
        atendimento.queueTypeID === 7 ||
        atendimento.queueTypeID === 8 ||
        atendimento.queueTypeID === 2)
    "
  />

  <Email v-else-if="!newCall && atendimento && atendimento.queueTypeID == 4" />
  <Ligacao v-else-if="newCall" />
  <v-card v-else flat color="#F7F7F7">
    <v-img
      class="mt-10"
      src="@/assets/fundowhats.jpeg"
      aspect-ratio="2"
      contain
      max-height="100%"
    ></v-img>
    <h5 style="text-align: center; color: #666">Xcontact Omni Channel</h5>
    <p style="text-align: center !important; color: #666">
      {{ t("fraseInicial") }}
    </p>
  </v-card>
</template>
   
<script>
import Chat from "../Chat";
import Email from "../Email";
import Ligacao from "../Ligacao";
import { mapState } from "vuex";

export default {
  name: "Atendimento-Index",
  props: {
    title: { type: String, default: "Title" },
  },
  components: {
    Chat,
    Ligacao,
    Email,
  },
  data: () => ({}),
  computed: {
    ...mapState("xc", {
      atendimento: (state) => state.atendimento,
    }),
    ...mapState("sip", {
      newCall: (state) => state.newCall,
    }),
  },

  methods: {},
};
</script>